<app-template-text (onblur)="onblur.emit()" [value]="value" [control]="control" [label]="label" />
